import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Table, Input, Button, Space, Popconfirm, message, Tag, Radio, Tooltip, Modal, Form, Select, Popover } from "antd";
import startCase from "lodash/startCase";
import capitalize from "lodash/capitalize";
import { Typography } from "antd";
import { DeleteOutlined, EditOutlined, EyeOutlined, CheckOutlined, CloseOutlined, SyncOutlined, FunnelPlotOutlined } from "@ant-design/icons";
import PlaylistForm from "../components/Playlists/PlaylistForm";
import axios from "axios";
import dayjs from "dayjs";
import { Helmet } from "react-helmet";
import { getMediaIcon } from "../utils/Misc";
import PreviewPlaylist from "../components/Playlists/PreviewPlaylist";
import RequirePermission from "../components/Common/RequirePermission";
const { Title } = Typography;
const { Option } = Select;

const Playlists = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(window.location.search);
  const initialStatus = queryParams.get("status") || "1";
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
  const [previewPlaylist, setPreviewPlaylist] = useState(null);
  const [playlists, setPlaylists] = useState([]);
  const [editingPlaylist, setEditingPlaylist] = useState(null);
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(initialStatus);
  const [approvePermission, setApprovePermission] = useState(false);
  const [createPermission, setCreatePermission] = useState(false);
  const [editPermission, setEditPermission] = useState(false);
  const [deletePermission, setDeletePermission] = useState(false);
  const [pendingTotal, setPendingTotal] = useState(0);
  const [rejectPlaylistId, setRejectPlaylistId] = useState(null);
  const [activeStatus, setActiveStatus] = useState("");
  const [selectedMedia, setSelectedMedia] = useState("");
  const [mediaOptions, setMediaOptions] = useState([]);
  const [syncLoading, setSyncLoading] = useState(false);
  const [showFilters, setShowFilters] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterText, setFilterText] = useState("");

  const setQueryParams = (params) => {
    const searchParams = new URLSearchParams(params);
    navigate(`?${searchParams.toString()}`, { replace: true });
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setFilterText(value);
    setCurrentPage(1);
  };

  const handleStatusChange = (value) => {
    setActiveStatus(value);
    const newQueryParams = {
      status: selectedStatus,
      activeStatus: value,
      media: selectedMedia
    };
    setQueryParams(newQueryParams);
    setCurrentPage(1);
  };

  const handleMediaChange = (value) => {
    setSelectedMedia(value);
    const newQueryParams = {
      status: selectedStatus,
      activeStatus: activeStatus,
      media: value,
    };
    setQueryParams(newQueryParams);
    setCurrentPage(1);
  }

  const handleTableChange = (pagination, filters, sorter) => {
    // if (typeof sorter.order === "undefined") {
    //   setSortingOrder("desc");
    //   setSortingColumn("id");
    // } else {
    //   setSortingColumn(sorter.field);
    //   setSortingOrder(sorter.order === "ascend" ? "asc" : "desc");
    // }
    setCurrentPage(pagination.current);
    setPageSize(pagination.pageSize);
  };

  const handleEdit = (record) => {
    setIsModalOpen(true);
    setEditingPlaylist(record);
  };

  const handleApprovalStatus = (e) => {
    const newStatus = e.target.value;
    setSelectedStatus(newStatus);
    const newQueryParams = {
      status: newStatus,
      activeStatus: activeStatus,
      media: selectedMedia
    };
    setQueryParams(newQueryParams);
    setCurrentPage(1);
  };

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BASE_URL}/api/playlists/${id}`
      );
      const updated_row_count = response.data.data.updated_row_count;
      if (updated_row_count === 1) {
        message.success("Playlist deleted");
        await fetchData();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handlePreviewPlaylist = (record) => {
    setIsPreviewModalOpen(true);
    setPreviewPlaylist({ ...record, media: JSON.parse(record.media_details) });
  };

  const handleApprove = async (id) => {
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_BASE_URL}/api/playlists/approve/${id}`
      );
      const updated_row_count = response.data.data.updated_row_count;
      if (updated_row_count === 1) {
        message.success("Playlist approved");
        await fetchData();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleReject = async (id, value) => {
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_BASE_URL}/api/playlists/reject/${id}`,
        {
          reason: value,
        }
      );
      const updated_row_count = response.data.data.updated_row_count;
      if (updated_row_count === 1) {
        message.success("Playlist rejected");
        await fetchData();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleSync = async () => {
    try {
      setSyncLoading(true);
      await axios.put(
        `${process.env.REACT_APP_BASE_URL}/api/playlists/sync`
      );
      message.success("Playlist synced successfully");
      await fetchData();
      setSyncLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchMaster = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/playlists/masters`
      );
      const media = response.data.data.media;

      setMediaOptions(
        media.map((mediaItem) => {
          const fileData = mediaItem.file_data
            ? JSON.parse(mediaItem.file_data)
            : {};
          const fileName = fileData.file_name || "";
          let extension = fileName.split(".").pop() || ""; // get extension

          if (extension === "") {
            extension = mediaItem.media_type;
          }

          return {
            value: mediaItem.id,
            type: mediaItem.media_type,
            label: (
              <>
                {getMediaIcon(mediaItem.media_type)}
                {mediaItem.title}{" "}
                <span style={{ color: "#888" }}>
                  ({extension.toUpperCase()})
                </span>
              </>
            ),
          };
        })
      );
      setLoading(false);
    } catch (err) {
      console.log(err);
    }
  }

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        process.env.REACT_APP_BASE_URL + `/api/playlists`,
        {
          params: {
            filter: filterText, // add filter if needed
            limit: pageSize,
            page: currentPage,
            status: selectedStatus,
            activeStatus: activeStatus,
            media: selectedMedia
          },
        }
      );
      let records = response.data.data.data;
      setTotalRecords(response.data.data.total);
      setPlaylists(records);
      setPendingTotal(response.data.data.pending_total);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching playlist data", error);
    }
  };

  useEffect(() => {
    const newQueryParams = {
      status: selectedStatus,
      activeStatus: activeStatus,
      media: selectedMedia
    };

    if (JSON.stringify(newQueryParams) !== JSON.stringify(Object.fromEntries(new URLSearchParams(location.search)))) {
      setQueryParams(newQueryParams);
    };

    setQueryParams(newQueryParams);
    const fetchTimer = setTimeout(() => {
      fetchData();
    }, 500);

    return () => clearTimeout(fetchTimer);
  }, [currentPage, pageSize, filterText, selectedStatus, activeStatus, selectedMedia]);

  useEffect(() => {
    fetchMaster();
  }, []);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("userData"));
    setUser(storedUser);
    const permissions = storedUser.permissions;
    setApprovePermission(
      parseInt(permissions["signage.playlist_approve"]) === 1
    );
    setCreatePermission(parseInt(permissions["signage.playlist_create"]) === 1);
    setDeletePermission(parseInt(permissions["signage.playlist_delete"]) === 1);
    setEditPermission(parseInt(permissions["signage.playlist_edit"]) === 1);
  }, []);

  const popOverColumns = [
    {
      title: "Id",
      dataIndex: "id",
      render: (text) => <span className="text-small">{startCase(text)}</span>,
    },
    {
      title: "Name",
      dataIndex: "name",
      render: (text) => <span className="text-small">{text?.toUpperCase()}</span>,
    },
  ];

  const columns = [
    { title: "Title", dataIndex: "title" },
    {
      title: "Media",
      dataIndex: "media_details",
      render: (text) => {
        const mediaData = JSON.parse(text);

        return (
          <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
            {mediaData.map((media) => (
              <Tag key={media.media_id}>
                {getMediaIcon(media.media_type)}
                {capitalize(media.title)}
                {media.media_type === "image" && ` (${media.duration} sec)`}
              </Tag>
            ))}
          </div>
        );
      },
    }];
  if (selectedStatus === "1") {
    columns.push({
      title: "Times played",
      dataIndex: "total_play_count",
      render: (text) => {
        return <span>{text ? text : 0}</span>;
      },
    });
  };
  columns.push({
    title: "Status",
    dataIndex: "status",
    render: (status) => (
      <Tag color={status === "active" ? "green" : "red"}>
        {capitalize(status)}
      </Tag>
    ),
  });
  if (selectedStatus === "1") {
    columns.push({
      title: "Approved At",
      dataIndex: "approved_at",
      render: (text) => (
        <span className="text-small">
          {dayjs(text).format("DD-MM-YYYY HH:mm")}
        </span>
      ),
    });
    columns.push({
      title: "Approved By",
      dataIndex: "approved_by",
      render: (text) => {
        return <span className="text-small">{startCase(text)}</span>;
      },
    });
  };
  if (selectedStatus === "1" || selectedStatus === "0") {
    columns.push({
      title: "Updated At",
      dataIndex: "modified_at",
      render: (text) => (
        <span className="text-small">
          {dayjs(text).format("DD-MM-YYYY HH:mm")}
        </span>
      ),
    });
    columns.push({
      title: "Updated By",
      dataIndex: "updated_by_user",
      render: (text) => {
        return <span className="text-small">{startCase(text)}</span>;
      },
    });
  };
  if (selectedStatus === "1") {
    columns.push({
      title: "Actions",
      render: (_, record) => (
        <Space>
          <Tooltip title="Preview Playlist">
            <Button
              size="small"
              icon={<EyeOutlined />}
              title="Preview"
              onClick={() => handlePreviewPlaylist(record)}
            />
          </Tooltip>
          {user && (
            <>
              {editPermission && (
                <Tooltip title="Edit Playlist">
                  <Button
                    size="small"
                    icon={<EditOutlined />}
                    onClick={() => handleEdit(record)}
                  />
                </Tooltip>
              )}
              {deletePermission && (
                <Tooltip title="Delete Playlist">
                  <Popconfirm
                    title="Are you sure to delete this playlist?"
                    onConfirm={() => handleDelete(record.id)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button danger size="small" icon={<DeleteOutlined />} />
                  </Popconfirm>
                </Tooltip>
              )}
            </>
          )}
        </Space>
      ),
    });
  };

  if (selectedStatus === "0") {
    columns.push({
      title: "Approval List",
      dataIndex: "approver_ids",
      render: (text, record) => {
        console.log(record);
        const len = record.approver_ids.length;
        if (len === 0) {
          return <Tag color="red">No Approver Assigned</Tag>;
        }

        if (len === 1) {
          return <Tag color="green">{record.approver_ids[0].name}</Tag>;
        }
        const sortedApprovers = [...record.approver_ids];
        return (
          <Popover
            placement="right"
            content={
              <Table
                loading={loading}
                columns={popOverColumns}
                dataSource={sortedApprovers}
                size="small"
                pagination={false}
                scroll={{ y: 400 }}
                style={{ width: "300px" }}
                rowKey="id"
              />
            }
            title="Assigned Approver List"
            trigger="hover"
          >
            <Tag style={{ cursor: "pointer" }} color="blue">
              {`${len} Approvers`}
            </Tag>
          </Popover>
        );
      },
    });
  }

  if (selectedStatus === "0" && approvePermission) {
    columns.push({
      title: "Actions",
      render: (_, record) => (
        <Space>
          <Tooltip title="Approve Playlist">
            <Popconfirm
              title="Are you sure to approve this playlist?"
              onConfirm={() => handleApprove(record.id)}
              okText="Yes"
              cancelText="No"
            >
              <Button
                size="small"
                style={{ color: "green", borderColor: "green" }}
                icon={<CheckOutlined />}
              />
            </Popconfirm>
          </Tooltip>
          <Tooltip title="Reject Playlist">
            <Button
              size="small"
              style={{ color: "red", borderColor: "red" }}
              icon={<CloseOutlined />}
              onClick={() => { setIsRejectModalOpen(true); setRejectPlaylistId(record.id) }}
            />
          </Tooltip>
        </Space>
      ),
    })
  };

  if (selectedStatus === "-1") {
    columns.push({
      title: "Rejected At",
      dataIndex: "rejected_at",
      render: (text) => (
        <span className="text-small">
          {dayjs(text).format("DD-MM-YYYY HH:mm")}
        </span>
      ),
    });
    columns.push({
      title: "Rejected By",
      dataIndex: "rejected_by",
      render: (text) => {
        return <span className="text-small">{startCase(text)}</span>;
      },
    });
    columns.push({
      title: "Reject Reason",
      dataIndex: "reject_reason",
      render: (text) => {
        return <span className="text-small">{text}</span>;
      },
    });
  }

  if (selectedStatus === "-1") {
    columns.push({
      title: "Actions",
      render: (_, record) => (
        <Space>
          {user && (
            <>
              {editPermission && (
                <Tooltip title="Edit Playlist">
                  <Button
                    size="small"
                    icon={<EditOutlined />}
                    onClick={() => handleEdit(record)}
                  />
                </Tooltip>
              )}
              {deletePermission && (
                <Tooltip title="Delete Playlist">
                  <Popconfirm
                    title="Are you sure to delete this playlist?"
                    onConfirm={() => handleDelete(record.id)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button danger size="small" icon={<DeleteOutlined />} />
                  </Popconfirm>
                </Tooltip>
              )}
            </>
          )}
        </Space>
      )
    })
  };

  return (
    <RequirePermission permission="signage.playlist_view">
      <div style={{ padding: "1rem" }}>
        <Helmet>
          <title>{`${process.env.REACT_APP_NAME} | Playlists`}</title>
        </Helmet>
        <Title level={3} style={{ marginBottom: "1rem" }}>
          Playlists
        </Title>
        <Radio.Group
          defaultValue={selectedStatus}
          buttonStyle="solid"
          className="mb-3"
          onChange={(e) => handleApprovalStatus(e)}
        >
          <Radio.Button value="1">Approved</Radio.Button>
          {approvePermission && (
            <Radio.Button value="0">
              Pending {pendingTotal > 0 && `(${pendingTotal})`}
            </Radio.Button>
          )}
          <Radio.Button value="-1">Rejected</Radio.Button>
        </Radio.Group>
        <div className="d-flex justify-content-between mb-3">
          <div className="d-flex gap-4">
            <Input.Search
              placeholder="Search playlist"
              value={filterText}
              onChange={handleSearch}
              style={{ width: 200 }}
            />

            <Button icon={<FunnelPlotOutlined />}
              onClick={() => setShowFilters(!showFilters)}
              style={{ color: showFilters ? 'green' : 'gray', borderColor: showFilters ? 'green' : 'gray', marginRight: "1rem", width: "30px", height: "30px" }}
            >
              {(selectedMedia || activeStatus) && <span style={{
                margin: "0px",
                position: "absolute",
                bottom: "85%",
                left: "85%",
                backgroundColor: "red",
                height: "8px",
                width: "8px",
                borderRadius: "50%",
                zIndex: 1,
              }}>
              </span>}
            </Button>

            {showFilters && <>{selectedStatus === "1" && <div>
              <span className="me-2">Status:</span>
              <Select
                value={activeStatus}
                showSearch
                onChange={(e) => handleStatusChange(e)}
                style={{ width: 200, marginRight: "1rem" }}
                allowClear
                placeholder="Select status"
              >
                <Option value="active">Active</Option>
                <Option value="inactive">Inactive</Option>
              </Select>
            </div>}
              {selectedStatus === "1" && <div>
                <span className="me-2">Media:</span>
                <Select
                  value={selectedMedia}
                  showSearch
                  placeholder="Select media"
                  onChange={(e) => handleMediaChange(e)}
                  style={{ width: 200, marginRight: "1rem" }}
                  allowClear
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.props.children[1]
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  {mediaOptions.map((media) => (
                    <Option key={media.value} value={media.value}>{media.label}</Option>
                  ))}
                </Select>
              </div>}</>}
          </div>
          {createPermission && (
            <div>
              <Button
                type="primary"
                onClick={() => {
                  setEditingPlaylist(null);
                  setIsModalOpen(true);
                }}
                style={{ marginRight: "1rem" }}
              >
                Add New Playlist
              </Button>
              {selectedStatus === "0" && (
                <Button
                  icon={<SyncOutlined />}
                  onClick={() => handleSync()}
                  loading={syncLoading}
                  disabled={syncLoading}
                  style={{ backgroundColor: "#0b59c0ff", color: "white" }}
                >
                  Sync
                </Button>
              )}
            </div>
          )}
        </div>

        <Table
          loading={loading}
          columns={columns}
          dataSource={playlists}
          scroll={{ x: "max-content" }}
          rowKey={(record) => record.id}
          onChange={handleTableChange}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: totalRecords,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} playlists`,
            showSizeChanger: true, // Enables the page size selection dropdown
            pageSizeOptions: ["5", "10", "20", "50", "100"], // Options for the page size selection
          }}
        />
        {isModalOpen && (
          <PlaylistForm
            isModalOpen={isModalOpen}
            closeModal={() => setIsModalOpen(false)}
            editingPlaylist={editingPlaylist}
            handleUpdateList={() => fetchData()}
          />
        )}
        {isPreviewModalOpen && (
          <PreviewPlaylist
            isModalOpen={isPreviewModalOpen}
            closeModal={() => setIsPreviewModalOpen(false)}
            playlist={previewPlaylist}
          />
        )}
        <Modal
          title="Reject Playlist"
          open={isRejectModalOpen}
          onCancel={() => setIsRejectModalOpen(false)}
          footer={null}
          maskClosable={false}
        >
          <Form
            name="Reject Playlist Textarea"
            initialValues={{ remember: true }}
            layout="vertical"
            style={{ maxWidth: 600 }}
            onFinish={(values) => { handleReject(rejectPlaylistId, values.reject_reason.trim()); setIsRejectModalOpen(false); }}
            onFinishFailed={(err) => { message.error(err.errorFields[0].errors[0]); }}
            autoComplete="off"
          >
            <Form.Item
              name="reject_reason"
              label="Reject Reason"
              rules={[
                {
                  required: true,
                  message: "Please enter the reject reason",
                },
              ]}
            >
              <Input.TextArea rows={4} />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Reject
              </Button>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    </RequirePermission>
  );
};

export default Playlists;
